//@flow
import { gql, graphql } from "react-apollo"
import type { KioskFormViewProps } from "../types"

const QUERY_KIOSK_DETAILS = gql`
  query getKioskDetailsAndOptions($id: ID!) {
    kiosk(id: $id) {
      id
      friendlyName
      shortName
      email
      language
      hidden
      latitude
      longitude
      usesVirtualKeyboard
      primarySensor {
        id
        stationId
        gasUrl
        particlesUrl
      }
      startsAt
      endsAt
    }
  }
`

const options = (props: KioskFormViewProps) => ({
  variables: {
    id: props.match.params.id
  }
})

const skip = (props: KioskFormViewProps): boolean =>
  typeof props.match.params.id === "undefined"

const withKioskFormDetails = graphql(QUERY_KIOSK_DETAILS, {
  options,
  skip,
  name: "details"
})

export default withKioskFormDetails



// WEBPACK FOOTER //
// ./src/Kiosks/queries/withKioskFormDetails.js